"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectConversationSortOrderOption')(function selectConversationSortOrderOption(sortOrder, state) {
    var optionState = state.optionState;
    optionState.conversationSortOrder = sortOrder;
}));
//# sourceMappingURL=selectConversationSortOrderOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/actions/selectConversationSortOrderOption.js
// module id = 5067
// module chunks = 2